import styled from '@emotion/styled'
import { Form } from 'formik'

import { WithTheme } from './../../../setup/index'
import media from '../../../common/MediaQueries'
import { transition } from './../../../common/Mixins'

export const ContactFormBoxStyled = styled.div<WithTheme>`
  max-width: 35.125rem;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 0px 1rem 0px rgba(107, 107, 107, 0.2);
  border-radius: 1rem;
  padding: 3.375rem 1.25rem;
`

export const ContactFormInnerStyled = styled.div`
  max-width: 25.375rem;
  margin: 0 auto;
`

export const ContactFormHeadStyled = styled.div`
  margin-bottom: 3.125rem;

  @media ${media.phone} {
    margin-bottom: 4.5rem;
  }
`

export const ContactFormStyled = styled(Form)`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`

export const ContactFormButtonStyled = styled.button`
  margin-left: auto;
  margin-right: auto;
`

export const ContactFormMsgStyled = styled.div`
  position: fixed;
  height: 100%;
  left: 0;
  right: 0;
  top: 0;
  z-index: 1000;

  @media ${media.maxTablet} {
    width: 100vw;
  }
  @media ${media.tablet} {
    width: 100%;
  }
`

export const ContactFormMsgOverlayStyled = styled.div`
  ${transition}
  position: fixed;
  background: rgba(255, 255, 255, 0.7);
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  z-index: 1;
  opacity: 0;
`

export const ContactFormMsgModalStyled = styled.div`
  ${transition}
  position: relative;
  width: 100%;
  overflow-y: auto;
  z-index: 2;
  height: 100%;
`

export const ContactFormMsgModalWrapperStyled = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;

  @media ${media.phone} {
    margin: 0 1.5rem;
  }
`
